import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/_dashboard/dashboard/quotes/edit/$quoteId')({
  params: z.object({ quoteId: z.string() })
});

export const useQuoteEditParams = () => Route.useParams();
